<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="期別開始，EX:11303"
          v-model="search.period_S"
          @keyup.enter="getBillFlatten(1)" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="期別結束，EX:11306"
          v-model="search.period_E"
          @keyup.enter="getBillFlatten(1)" />
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getBillFlatten(1)">搜尋</b-button>
        </div>
      </div>

    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getBillFlatten"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import { convertRocDate, countNoNum } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'claimReport',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '墊繳報表', url: '', isActive: false }
        ]
      },
      options: {

      },
      search: {
        behalf: 1,
        bill_type: 'M',
        period_S: '',
        period_E: ''
      },
      status: {

      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "pay_name",
            label: "要助人",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務員",
            sortable: true
          },
          {
            key: "amount",
            label: "互助金",
            sortable: true
          }
        ],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
        temp_table_data: {}
      }
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.billApi.page);
      this.getBillFlatten();
    },
    countNoNum,
    convertRocDate,
    // 查詢帳單
    getBillFlatten(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.billApi.getBillFlatten((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        behalf: 1,
        bill_type: 'M',
        period_S: '',
        period_E: ''
      }

      this.getBillFlatten(1);
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="file"] {
  display: none;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/claimReport.vue